import { z } from '../zod.js';
/**
 * The callout map (baseline section 4, "Notion paste"; 1.0b deliverable 14, orchestrator ruling
 * 17): the one callout-map shape of Phase 1, stored as the `callout_map` setting. 1.0c's doc-model
 * mirrors it under the same names without Zod and owns its semantics (`validateCalloutMap`,
 * `resolveCallout`, `DEFAULT_CALLOUT_MAP`); 1.H applies it; 1.V-2's settings screen edits it.
 * Stage 3's parity spec proves this schema agrees with 1.0c's shared cases file.
 */
/** Notion's hues, in this order. Callers turn Notion's text and background variants into their hue first. */
export const NOTION_COLORS = [
    'gray',
    'brown',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'pink',
    'red',
];
export const NotionColor = z.enum(NOTION_COLORS);
/** What a pasted Notion callout becomes, in this order. */
export const CALLOUT_TARGETS = ['callout', 'readAloud', 'secret', 'gmNote'];
export const CalloutTarget = z.enum(CALLOUT_TARGETS);
/**
 * An icon of 1 to 64 UTF-16 code units. Zod's own length checks count code points, so the bound is
 * a pattern, which counts code units outside unicode mode (an emoji is two).
 */
export const CALLOUT_ICON_PATTERN = /^[\s\S]{1,64}$/;
/**
 * One rule: callouts matching `match` (an icon, a hue, both, or neither) become `to`; `tone`,
 * when present, is the tone a resulting callout takes (null for none). No other key is allowed,
 * at either level.
 */
export const CalloutMapEntryV1 = z.strictObject({
    match: z.strictObject({
        icon: z.string().regex(CALLOUT_ICON_PATTERN).optional(),
        color: NotionColor.optional(),
    }),
    to: CalloutTarget,
    tone: NotionColor.nullable().optional(),
});
/** At most 100 entries; the first that applies wins (1.0c's `resolveCallout`). */
export const CalloutMapV1 = z.array(CalloutMapEntryV1).max(100);
//# sourceMappingURL=callout-map.js.map